/* ==========================================================================
   AMADA 写评论页
   --------------------------------------------------------------------------
   提交与传图通道均为 Judge.me 官方 widget 自己在用的接口，**免 api_token**
   （从其 widget/form.js 反查 + 2026-08-03 实测）：

     传图  GET  https://api.judge.me/api/v1/pictures/presigned_data
                ?url=<shop>&shop_domain=<shop>&platform=shopify
                → { url, key_prefix, fields }  然后 POST FormData 直传 S3，
                  从返回 XML 里取 <Key> 作为 picture_keys[i]
     提交  POST https://api.judge.me/api/v1/reviews   （multipart/form-data）
                url / shop_domain / platform / id / name / email / rating / title / body
                / reviewer_name_format / picture_keys[i]

   稿：figma-qa/specs/reviews-pc-2026-08-03.md §10–14
       figma-qa/specs/reviews-mobile-2026-08-03.md §13
   ========================================================================== */
(function () {
  'use strict';

  var API_BASE = 'https://api.judge.me/api/v1';
  // S3 直传的超时。fetch 本身没有默认超时，不设的话连不上时会无限转圈
  var UPLOAD_TIMEOUT = 25000;

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    if (window.Shopify && window.Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      try {
        return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
      } catch (e) {
        /* 落回下面 */
      }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function param(name) {
    var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }

  function WriteReview(root) {
    this.root = root;
    this.shopDomain = root.getAttribute('data-shop-domain');
    this.minLength = parseInt(root.getAttribute('data-min-length'), 10) || 50;
    this.maxLength = parseInt(root.getAttribute('data-max-length'), 10) || 500;
    this.successUrl = root.getAttribute('data-success-url') || '';
    this.successText =
      root.getAttribute('data-success-text') ||
      'Thank you for your review! Your feedback has been submitted successfully';

    this.rating = 0;
    this.product = null;
    this.pictureKeys = [];
    this.uploading = 0;
    this.submitting = false;
    this.submitted = false; // 提交成功后置灰（运营要的第三态），用户再动表单就恢复

    var q = root.querySelector.bind(root);
    this.el = {
      form: q('[data-wr-form]'),
      stars: q('[data-wr-stars]'),
      title: q('[data-wr-title]'),
      body: q('[data-wr-body]'),
      name: q('[data-wr-name]'),
      email: q('[data-wr-email]'),
      counter: q('[data-wr-counter]'),
      anon: q('[data-wr-anon]'),
      submit: q('[data-wr-submit]'),
      error: q('[data-wr-error]'),
      success: q('[data-wr-success]'),
      file: q('[data-wr-file]'),
      uploadTrigger: q('[data-wr-upload-trigger]'),
      thumbs: q('[data-wr-thumbs]'),
      product: q('[data-wr-product]'),
      modal: q('[data-wr-modal]'),
      modalText: q('[data-wr-modal-text]'),
    };

    this.bind();
    this.loadProduct();
    this.autoGrow();
    this.syncSubmitState();
  }

  /* ---------- 商品 ---------- */

  WriteReview.prototype.loadProduct = function () {
    var self = this;
    var handle = param('product') || param('handle');
    if (!handle) {
      this.showError('No product specified. Please open this page from a product.');
      return;
    }

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product ' + r.status);
        return r.json();
      })
      .then(function (p) {
        self.product = p;
        self.renderProduct(p);
      })
      .catch(function () {
        self.showError('Could not load that product.');
      });
  };

  WriteReview.prototype.renderProduct = function (p) {
    var box = this.el.product;
    if (!box) return;
    box.hidden = false;

    var img = box.querySelector('[data-wr-product-image]');
    if (p.featured_image) {
      // Shopify CDN 支持 &width= 缩放，取 2 倍图保证高分屏清晰
      img.src = p.featured_image.replace(/(\.(jpg|jpeg|png|webp))/i, '_400x$1');
      img.alt = p.title || '';
    } else {
      img.hidden = true;
    }

    var titleEl = box.querySelector('[data-wr-product-title]');
    titleEl.textContent = p.title || '';
    titleEl.href = '/products/' + p.handle;

    /* 稿左栏在商品名下面列了两行规格（Frame cover / Material）。
       真实商品没有这两个固定字段，用变体选项名值兜底，没有就整行不显示。 */
    var specs = box.querySelector('[data-wr-product-specs]');
    var variant = p.variants && p.variants[0];
    var lines = [];
    if (p.options && variant) {
      p.options.forEach(function (opt, i) {
        var value = variant['option' + (i + 1)];
        var name = typeof opt === 'string' ? opt : opt.name;
        if (value && name) lines.push(name + ': ' + value);
      });
    }
    if (lines.length) specs.innerHTML = lines.map(esc).join('<br>');
    else specs.hidden = true;

    var now = box.querySelector('[data-wr-price-now]');
    var was = box.querySelector('[data-wr-price-was]');
    /* /products/xxx.js 的 price 是**最低变体价**，多变体商品会与详情页当前变体价对不上
       （实测：详情页 $799.99，这里拿到 $269.99）。价格有区间时显式标 From，避免误导。 */
    now.textContent = (p.price_varies ? 'From ' : '') + money(p.price);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      was.hidden = false;
      was.textContent = money(p.compare_at_price);
    }
  };

  /* ---------- 交互 ---------- */

  WriteReview.prototype.bind = function () {
    var self = this;

    // 星级
    this.el.stars.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wr-star]');
      if (!btn) return;
      self.rating = parseInt(btn.getAttribute('data-wr-star'), 10);
      self.renderStars();
      self.syncSubmitState();
    });

    // 键盘可达（稿只画了鼠标态，但单选组必须能用键盘选）
    this.el.stars.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var next = self.rating + (e.key === 'ArrowRight' ? 1 : -1);
      self.rating = Math.min(5, Math.max(1, next));
      self.renderStars();
      self.syncSubmitState();
    });

    this.el.body.addEventListener('input', function () {
      self.el.counter.textContent = self.el.body.value.length + '/' + self.maxLength;
      self.submitted = false; // 提交完又开始写新的一条 → 按钮从灰恢复成黄
      self.autoGrow();
      self.syncSubmitState();
    });

    [this.el.title, this.el.name, this.el.email].forEach(function (input) {
      input.addEventListener('input', function () {
        self.submitted = false;
        self.syncSubmitState();
      });
    });

    this.el.uploadTrigger.addEventListener('click', function () {
      self.el.file.click();
    });

    this.el.file.addEventListener('change', function () {
      var files = Array.prototype.slice.call(self.el.file.files || []);
      files.forEach(function (f) {
        self.uploadPicture(f);
      });
      self.el.file.value = ''; // 允许再次选同一张
    });

    this.el.thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wr-thumb-remove]');
      if (!btn) return;
      var key = btn.getAttribute('data-wr-thumb-remove');
      self.pictureKeys = self.pictureKeys.filter(function (k) {
        return k !== key;
      });
      btn.closest('.amada-wr__thumb').remove();
      self.syncUploadState();
    });

    this.el.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.submit();
    });

    this.root.addEventListener('click', function (e) {
      if (e.target.closest('[data-wr-modal-close]')) self.closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeModal();
    });
  };

  /* 稿把 UPLOAD IMAGES 画了两态：未选图白底描边、已选图黄底白字（182:560 / 182:627）。
     判据用「缩略图容器里有没有东西」而不是 pictureKeys —— 上传中的图已经有缩略图但还没拿到 key，
     那一刻按钮也该是激活的，否则会闪一下白底。 */
  WriteReview.prototype.syncUploadState = function () {
    if (!this.el.uploadTrigger || !this.el.thumbs) return;
    this.el.uploadTrigger.classList.toggle('is-active', this.el.thumbs.children.length > 0);
  };

  WriteReview.prototype.renderStars = function () {
    var stars = this.el.stars.querySelectorAll('[data-wr-star]');
    for (var i = 0; i < stars.length; i++) {
      var value = i + 1;
      var on = value <= this.rating;
      stars[i].classList.toggle('is-on', on);
      stars[i].setAttribute('aria-checked', String(value === this.rating));
    }
  };

  /* ---------- 图片：预签名 → S3 直传 ---------- */

  WriteReview.prototype.uploadPicture = function (file) {
    var self = this;
    if (!/^image\//.test(file.type)) return;
    // Judge.me 侧对单图有大小限制，太大的直接拦下，别等 S3 报错
    if (file.size > 10 * 1024 * 1024) {
      this.showError('Each image must be under 10MB.');
      return;
    }

    var shopParams =
      'url=' + encodeURIComponent(this.shopDomain) +
      '&shop_domain=' + encodeURIComponent(this.shopDomain) +
      '&platform=shopify';

    var thumb = document.createElement('div');
    thumb.className = 'amada-wr__thumb is-loading';
    thumb.innerHTML = '<img alt="">';
    thumb.querySelector('img').src = URL.createObjectURL(file);
    this.el.thumbs.appendChild(thumb);
    this.syncUploadState();

    this.uploading += 1;
    this.syncSubmitState();

    fetch(API_BASE + '/pictures/presigned_data?' + shopParams)
      .then(function (r) {
        if (!r.ok) throw new Error('presign ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var fd = new FormData();
        Object.keys(data.fields || {}).forEach(function (k) {
          fd.append(k, data.fields[k]);
        });
        // key 必须自己拼：预签名只给前缀，文件名由客户端定
        var key = (data.key_prefix || '') + Date.now() + '-' + file.name.replace(/[^\w.-]/g, '_');
        fd.append('key', key);
        fd.append('Content-Type', file.type);
        fd.append('file', file);

        /* S3 直传必须自己设超时：fetch 没有默认超时，s3.amazonaws.com 一旦不可达
           （某些地区/网络会直接 ERR_CONNECTION_CLOSED），缩略图会无限转圈，
           用户既看不到进度也等不到失败 —— 2026-08-04 运营验收就卡在这里。 */
        var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timedOut = false;
        var timer = setTimeout(function () {
          timedOut = true;
          if (ctrl) ctrl.abort();
        }, UPLOAD_TIMEOUT);

        var opts = { method: 'POST', body: fd };
        if (ctrl) opts.signal = ctrl.signal;

        return fetch(data.url, opts).then(
          function (res) {
            clearTimeout(timer);
            if (!res.ok) throw new Error('s3 ' + res.status);
            return res.text().then(function (xml) {
              // S3 返回 XML，优先用它回的 Key（可能与我们拼的不同）
              var m = /<Key>([^<]+)<\/Key>/.exec(xml);
              return m ? decodeURIComponent(m[1]) : key;
            });
          },
          function (err) {
            clearTimeout(timer);
            throw new Error(timedOut ? 'timeout' : String(err && err.message ? err.message : err));
          }
        );
      })
      .then(function (key) {
        self.pictureKeys.push(key);
        thumb.classList.remove('is-loading');
        thumb.insertAdjacentHTML(
          'beforeend',
          '<button type="button" class="amada-wr__thumb-remove" data-wr-thumb-remove="' + esc(key) + '" aria-label="Remove image">×</button>'
        );
      })
      .catch(function (err) {
        thumb.remove();
        // 超时/连不上单独提示：这是网络到 S3 不通，不是图片本身有问题
        var isNet = err && /timeout|Failed to fetch|NetworkError|aborted/i.test(String(err.message || err));
        self.showError(
          isNet
            ? 'Could not reach the image server. Please check your connection and try again — you can still submit the review without photos.'
            : 'Image upload failed. You can still submit the review without it.'
        );
      })
      .then(function () {
        self.uploading -= 1;
        self.syncUploadState(); // 上传失败缩略图被移除，按钮要退回未激活态
        self.syncSubmitState();
      });
  };

  /* ---------- 校验与提交 ---------- */

  WriteReview.prototype.bodyTooShort = function () {
    return this.el.body.value.trim().length < this.minLength;
  };

  WriteReview.prototype.isReady = function () {
    return (
      this.rating > 0 &&
      !this.bodyTooShort() &&
      this.el.name.value.trim() &&
      /\S+@\S+\.\S+/.test(this.el.email.value.trim()) &&
      !this.uploading &&
      !this.submitting
    );
  };

  /* SUBMIT 三态（运营 2026-08-04 确认，与稿 Frame 9997 一致）：
       进页面就是黄 #FFC40C → hover 深黄 #FFAE0D → 提交完成后灰 #E4E4E4。
     所以按钮**默认可点**，不再按「填没填够」置灰 —— 校验交给点击时的弹窗
     （submit() 里已有：没评分 / 正文不足 50 字 / 邮箱不合法各自弹一条）。
     早先按 isReady() 置灰是我从「两态稿」反推的，反推错了：空表单那帧画的就是黄色。 */
  WriteReview.prototype.syncSubmitState = function () {
    var busy = this.submitting || this.uploading > 0;
    this.el.submit.disabled = busy || this.submitted;
    this.el.submit.classList.toggle('is-ready', !busy && !this.submitted);
  };

  /* Description 初始只有稿里的一行高，写满自动往下长（运营 2026-08-04）。
     先归零再取 scrollHeight —— 不归零的话内容删短时高度降不回来。 */
  WriteReview.prototype.autoGrow = function () {
    var ta = this.el.body;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = ta.scrollHeight + 'px';
  };

  WriteReview.prototype.showError = function (msg) {
    this.el.error.hidden = false;
    this.el.error.textContent = msg;
  };

  /* isSuccess 区分两种弹窗：校验提示点 OKEY 只是关掉继续填，
     提交成功点 OKEY 要跳走（稿 Frame 10008）。外观两者一致，只有行为不同。 */
  WriteReview.prototype.openModal = function (text, isSuccess) {
    this.el.modalText.textContent = text;
    this.el.modal.hidden = false;
    this.modalIsSuccess = !!isSuccess;
    this.el.modal.classList.toggle('is-success', !!isSuccess);
    document.body.style.overflow = 'hidden';
  };

  WriteReview.prototype.closeModal = function () {
    this.el.modal.hidden = true;
    document.body.style.overflow = '';
    if (this.modalIsSuccess) {
      this.modalIsSuccess = false;
      // 成功弹窗关掉才跳，没配跳转地址就留在原页（表单已重置，可以再写一条）
      if (this.successUrl) window.location.href = this.successUrl;
    }
  };

  WriteReview.prototype.submit = function () {
    var self = this;
    this.el.error.hidden = true;

    if (!this.product) {
      this.openModal('Product not loaded yet. Please refresh and try again.');
      return;
    }
    if (!this.rating) {
      this.openModal('Please select a rating first.');
      return;
    }
    // 稿的校验弹窗就是这一条（PC 2013:2827 / 移动 2011:294）
    if (this.bodyTooShort()) {
      this.openModal('The review description should have at least ' + this.minLength + ' characters');
      return;
    }
    if (!/\S+@\S+\.\S+/.test(this.el.email.value.trim())) {
      this.openModal('Please enter a valid email address.');
      return;
    }

    this.submitting = true;
    this.syncSubmitState();

    var fd = new FormData();
    fd.append('url', this.shopDomain);
    fd.append('shop_domain', this.shopDomain);
    fd.append('platform', 'shopify');
    fd.append('id', String(this.product.id));
    fd.append('name', this.el.name.value.trim());
    fd.append('email', this.el.email.value.trim());
    fd.append('rating', String(this.rating));
    fd.append('title', this.el.title.value.trim());
    fd.append('body', this.el.body.value.trim());
    // Judge.me 的匿名投稿用 reviewer_name_format=anonymous
    if (this.el.anon.checked) fd.append('reviewer_name_format', 'anonymous');
    this.pictureKeys.forEach(function (key, i) {
      fd.append('picture_keys[' + i + ']', key);
    });

    fetch(API_BASE + '/reviews', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) throw new Error('submit ' + r.status);
        return r.json().catch(function () {
          return {};
        });
      })
      .then(function () {
        self.el.form.reset();
        self.rating = 0;
        self.pictureKeys = [];
        self.el.thumbs.innerHTML = '';
        self.syncUploadState();
        self.renderStars();
        self.el.counter.textContent = '0/' + self.maxLength;
        self.autoGrow(); // 表单已 reset，高度也要收回一行
        /* 稿 v2 的 Frame 10008 把「提交成功」也画成了弹窗（与校验弹窗同款白框 + 黄色 OKEY），
           不再是页面里的一条提示。跳转推迟到点 OKEY 之后 —— 原来 1.8s 自动跳，
           用户还没读完文案就被带走了。 */
        self.submitted = true; // 提交完成 → SUBMIT 转灰（三态里的第三态）
        self.el.success.hidden = false; // 视觉上被 visually-hidden 藏着，留给读屏播报
        self.openModal(self.successText, true);
      })
      .catch(function () {
        self.showError('Sorry, we could not submit your review. Please try again later.');
      })
      .then(function () {
        self.submitting = false;
        self.syncSubmitState();
      });
  };

  function boot() {
    var blocks = document.querySelectorAll('[data-amada-write-review]');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].__amadaWriteReview) continue;
      blocks[i].__amadaWriteReview = new WriteReview(blocks[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
